import { EmptyBoxIcon, NotFoundIcon } from 'assets/icons';
import { ReactNode } from 'react';

export function NoResultsFound({
  title,
  subTitle,
  className = 'text-gray-600',
  Icon = <EmptyBoxIcon className="w-20 h-20 " />,
}: {
  title?: string;
  subTitle?: string;
  Icon?: ReactNode;
  className?: string;
}) {
  return (
    <div className={`flex flex-col items-center text-center mt-8 ${className}`}>
      {Icon}

      <div className="mt-4 font-semibold capitalize">{title}</div>
      <div className="mt-2 text-sm whitespace-pre-wrap">{subTitle}</div>
    </div>
  );
}
